export default {
  data() {
    return {
      months: [
        {
          key: "January",
          value: "message.monthJanuary"
        },
        {
          key: "February",
          value: "message.monthFebruary"
        },
        {
          key: "March",
          value: "message.monthMarch"
        },
        {
          key: "April",
          value: "message.monthApril"
        },
        {
          key: "May",
          value: "message.monthMay"
        },
        {
          key: "June",
          value: "message.monthJune"
        },
        {
          key: "July",
          value: "message.monthJuly"
        },
        {
          key: "August",
          value: "message.monthAugust"
        },
        {
          key: "September",
          value: "message.monthSeptember"
        },
        {
          key: "October",
          value: "message.monthOctober"
        },
        {
          key: "November",
          value: "message.monthNovember"
        },
        {
          key: "December",
          value: "message.monthDecember"
        }
      ]
    }
  },
  methods: {
    localizeMonth(key) {
      let self = this;
      let localization = self.months.filter(function (item) {
        return item.key === key;
      });
      if(localization.length === 1) {
        return self.$t(localization[0].value);
      }
      else {
        return key
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/DateMonths/index.js